import { render, staticRenderFns } from "./DogePrice.vue?vue&type=template&id=4a6fb3fe&scoped=true&"
import script from "./DogePrice.vue?vue&type=script&lang=js&"
export * from "./DogePrice.vue?vue&type=script&lang=js&"
import style0 from "./DogePrice.vue?vue&type=style&index=0&id=4a6fb3fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6fb3fe",
  null
  
)

export default component.exports